import { useQuery } from '@tanstack/react-query';

import { keysToCamel } from '@shared/helpers/snakeToCamel';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

import { getTeamData } from '../../api';
import { IMyTeam } from '../../model/types';

export const useGetTeam = () => {
    const {
        isLoading: isGetTeamLoading,
        isFetching,
        data,
        isSuccess,
    } = useQuery<IDataResponse<IMyTeam>, Error, IMyTeam>({
        queryKey: ['myTeam'],
        queryFn: getTeamData,
        staleTime: 1000 * 60 * 5,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        select: (response: IDataResponse<IMyTeam>) => keysToCamel(response.data),
    });

    return { isGetTeamLoading, isFetching, isSuccess, data };
};
